<template>
  <div>
    <div id="owner_view_business_name_section" style="height: 0px; width: 0px">
      &nbsp;my name&nbsp;
    </div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      @on-scroll-to="scroll_to"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    ></BusinessViewHeader>

    <div class="pt-8 pb-4 white text-center pr-8" v-if="header_buttons.length > 0 && is_in_public_view == false" >
      <v-btn
        v-for="(btn, index) in header_buttons"
        :key="index"
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        :color="btn.color"
        @click="on_click_header_action(btn)"
      >
        <v-icon left>{{ btn.icon }}</v-icon
        >{{ btn.label }}
      </v-btn>
    </div>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Description"
      id="owner_view_business_description_section"
    ></CardedSectionHeader>
    <BusinessViewDescription
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    >
    </BusinessViewDescription>
    <CardedSectionHeader
      icon="mdi-star"
      label="Please Rate This Business"
      id="owner_view_business_rate_form_section"
    ></CardedSectionHeader>
    <BusinessViewRateForm
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :user="this_user"
      @on-success-rated="finished_rating_business"
      @on-not-loggedin="no_rate_user_not_loggedin"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    >
    </BusinessViewRateForm>
    <CardedSectionHeader
      icon="mdi-map"
      label="Location"
      id="owner_view_business_location_section"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner && is_in_admin_view == false && is_in_public_view == false"
        :to="
          '/owner/businesses/list/view/' +
          this.business_id +
          '/locations/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Location Info
      </v-btn>
    </CardedSectionHeader>
    <BusinessViewLocation
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    >
    </BusinessViewLocation>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Working Schedules "
      id="owner_view_business_working_schedules_section"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner && is_in_admin_view == false && is_in_public_view == false"
        :to="
          '/owner/businesses/list/view/' +
          this.business_id +
          '/holidaysschedule/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Holidays Schedule
      </v-btn>

      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner  && is_in_admin_view == false && is_in_public_view == false"
        :to="
          '/owner/businesses/list/view/' + this.business_id + '/schedule/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Weekly Schedule
      </v-btn>
    </CardedSectionHeader>
    <BusinessViewSchedule
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :key="business_schedule_key"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    >
    </BusinessViewSchedule>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Contact Information"
      id="owner_view_business_contact_info_section"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner && is_in_admin_view == false && is_in_public_view == false"
        :to="
          '/owner/businesses/list/view/' + this.business_id + '/contacts/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Contact Info
      </v-btn>
    </CardedSectionHeader>
    <BusinessViewContacts
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    >
    </BusinessViewContacts>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Contact This Business Via a Message"
      id="owner_view_business_contact_us_form_section"
    ></CardedSectionHeader>
    <BusinessViewSendMessage
      :business="business"
      :user_id="user_id"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    >
    </BusinessViewSendMessage>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Photo Gallery "
      id="owner_view_business_photo_gallery_section"
    >
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        :disabled="is_loading"
        color="success"
        v-if="is_owner && is_in_admin_view == false && is_in_public_view == false"
        :to="
          '/owner/businesses/list/view/' + this.business_id + '/gallery/manage'
        "
      >
        <v-icon left>mdi-pen</v-icon>
        Manage Your Photos
      </v-btn>
    </CardedSectionHeader>
    <div class="pa-5 white">
      <PlainDisplay
        icon="mdi-eye"
        :title="'Click on the photo to view it'"
        v-if="business_images.length > 0"
      >
        <v-gallery :images="business_images"> </v-gallery>
      </PlainDisplay>
      <PlainDisplay
        icon="mdi-eye"
        :title="'!!Oops, no photoes uploaded'"
        v-if="business_images.length == 0 && (is_owner == false || is_in_admin_view == true)"
      >
        //nyd //image here for oops no images
      </PlainDisplay>
      <PlainDisplay
        icon="mdi-eye"
        :title="'!!Oops, no photoes uploaded'"
        v-if="business_images.length == 0 && is_owner == true && is_in_admin_view == false"
      >
        //nyd //image here for oops no images ==> Alert to guide owner wher to
        click to upload image
      </PlainDisplay>
    </div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Hash Tags"
      id="owner_view_business_meta_section"
    ></CardedSectionHeader>
    <BusinessViewHashTags
      :business="business"
      :user_id="user_id"
      :is_loading="is_loading"
      :is_owner="is_owner"
      @on-success-tags-updated="on_success_tags_updated"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    >
    </BusinessViewHashTags>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Reviews List "
      id="owner_view_business_reviews_list_section"
    ></CardedSectionHeader>
    <div class="white">
      <v-row v-for="(review, index) in business.reviews" :key="index">
        <v-col cols="1" class="pr-0">
          <v-avatar
            size="50px"
            :color="
              colors_list[Math.floor(Math.random() * (colors_list.length - 1))]
            "
          >
            <span class="white--text"
              >{{ review.user.first_name[0] }}
              {{ review.user.last_name[0] }}</span
            >
          </v-avatar>
        </v-col>
        <v-col class="text-left">
          <div class="grey--text">
            {{ review.posted_on }} --
            <small
              ><b
                >{{ review.user.first_name }} {{ review.user.last_name }}</b
              ></small
            >
          </div>
          {{ review.comment }}
          <v-divider></v-divider>
        </v-col>
      </v-row>
       <v-row  v-if="business.reviews.length == 0">
         <v-col>
            //nyd
            //No reviews sad emoji and text to users
         </v-col>
       </v-row>
    </div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Please Review This Business"
      id="owner_view_business_review_form_section"
    ></CardedSectionHeader>
    <BusinessViewReviewForm
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      @on-success-reviewed="finished_review_business"
      @on-not-loggedin="no_review_user_not_loggedin"
      :is_in_admin_view="is_in_admin_view"
      :is_in_public_view="is_in_public_view"
    >
    </BusinessViewReviewForm>

    <!-- 
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Searches List "
      id="owner_view_business_searches_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Views List "
      id="owner_view_business_views_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Ratings List "
      id="owner_view_business_ratings_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Messages List "
      id="owner_view_business_messages_list_section"
    ></CardedSectionHeader>

    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Activity Graph "
      id="owner_view_business_activity_graph_section"
    ></CardedSectionHeader> -->

    <br />
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import PlainDisplay from "./../../../components/PlainDisplay";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import BusinessViewDescription from "./../../../components/BusinessViewDescription";
import BusinessViewRateForm from "./../../../components/BusinessViewRateForm";
import BusinessViewLocation from "./../../../components/BusinessViewLocation";
import BusinessViewSchedule from "./../../../components/BusinessViewSchedule";
import BusinessViewContacts from "./../../../components/BusinessViewContacts";
import BusinessViewSendMessage from "./../../../components/BusinessViewSendMessage";
import BusinessViewHashTags from "./../../../components/BusinessViewHashTags";
import BusinessViewReviewForm from "./../../../components/BusinessViewReviewForm";

import CardedDisplay from "./../../../components/CardedDisplay";
export default {
  name: "OwnerBusinessesView",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
    BusinessViewHeader,
    BusinessViewDescription,
    BusinessViewRateForm,
    BusinessViewLocation,
    BusinessViewSchedule,
    BusinessViewContacts,
    BusinessViewSendMessage,
    BusinessViewHashTags,
    BusinessViewReviewForm,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      _user: null,
      business: Utils.get_default_business(),
      is_owner: false,
      business_schedule_key: "bsk_1",
      business_schedule_key_count: 1,
      user_id: 0,
      colors_list: ["grey","indigo","pink","orange","blue","red","green","warning","info","yellow","black"]
    };
  },
  methods: {
    send_parent_page_set_up() {
      if (this.is_owner && this.is_in_admin_view == false && this.is_in_public_view == false) {
        //the business owner
        //also will not have adverts on the right but
        //some sections on this page are skipped
        this.$emit("set-page-attributes", {
          title: "Business Details",
          crumps: [
            {
              text: "Owner",
              disabled: false,
              href: "/owner",
            },
            {
              text: "Buinesses",
              disabled: false,
              href: "/owner/businesses/",
            },
            {
              text: "List",
              disabled: false,
              href: "/owner/businesses/list",
            },
            {
              text: "View",
              disabled: true,
              href: "/owner/businesses/list/view/" + this.business_id,
            },
          ],
          navbar_cols: 3,
          right_quick_links: [
            {
              text: "Business Name",
              href: "#owner_view_business_name_section",
            },
            {
              text: "Business Description",
              href: "#owner_view_business_description_section",
            },
            // {
            //   text: "Rate This Business",
            //   href: "#owner_view_business_rate_form_section",
            // },
            {
              text: "Location Info",
              href: "#owner_view_business_location_section",
            },
            {
              text: "Working Schedules",
              href: "#owner_view_business_working_schedules_section",
            },
            {
              text: "Contact Information",
              href: "#owner_view_business_contact_info_section",
            },
            // {
            //   text: "Contact / Message Form",
            //   href: "#owner_view_business_contact_us_form_section",
            // },
            {
              text: "Photo Gallery",
              href: "#owner_view_business_photo_gallery_section",
            },
            {
              text: "Hash/ Search Tags",
              href: "#owner_view_business_meta_section",
            },
            {
              text: "Business Reviews",
              href: "#owner_view_business_reviews_list_section",
            },
            // {
            //   text: "Post a Review Form",
            //   href: "#owner_view_business_review_form_section",
            // },
          ],
        });
      } else if(this.is_in_admin_view == true){
        //the admin doesnot not need adverts on the right
        //and the admin is interested in viewing all sections on
        //the business details page
        this.$emit("set-page-attributes", {
          title: "Business Details",
          crumps: [
            {
              text: "Admin",
              disabled: false,
              href: "/admin",
            },
            {
              text: "Businesses",
              disabled: false,
              href: "/admin/businesses",
            },
            {
              text: "List",
              disabled: false,
              href: "/admin/businesses/list",
            },
            {
              text: "View",
              disabled: true,
              href: "/admin/businesses/list/view/" + this.business_id,
            },
          ],
          right_quick_links: [
            {
              text: "Business Name",
              href: "#owner_view_business_name_section",
            },
            {
              text: "Business Description",
              href: "#owner_view_business_description_section",
            },
            {
              text: "Rate This Business",
              href: "#owner_view_business_rate_form_section",
            },
            {
              text: "Location Info",
              href: "#owner_view_business_location_section",
            },
            {
              text: "Working Schedules",
              href: "#owner_view_business_working_schedules_section",
            },
            {
              text: "Contact Information",
              href: "#owner_view_business_contact_info_section",
            },
            {
              text: "Contact / Message Form",
              href: "#owner_view_business_contact_us_form_section",
            },
            {
              text: "Photo Gallery",
              href: "#owner_view_business_photo_gallery_section",
            },
            {
              text: "Hash/ Search Tags",
              href: "#owner_view_business_meta_section",
            },
            {
              text: "Business Reviews",
              href: "#owner_view_business_reviews_list_section",
            },
            {
              text: "Post a Review Form",
              href: "#owner_view_business_review_form_section",
            },
          ],
        });
      } else if (this.is_in_public_view == true){
        
        //the public will have adverts on the left side
        //so we shall push these on to the right and
        //we can afford to leave out the promotions ads
        this.$emit("set-page-attributes", {
          title: "Business Details",
          crumps: [
            {
              text: "Home",
              disabled: false,
              href: "/",
            },
            {
              text: "View",
              disabled: true,
              href: "/businesses/" + this.business_id,
            },
          ],
          right_quick_links: [],
        });
        //send the quick links on the right
        this.$emit("set-master-page-attrs", {
          quick_links: [{
              text: "Business Name",
              href: "#owner_view_business_name_section",
            },
            {
              text: "Business Description",
              href: "#owner_view_business_description_section",
            },
            {
              text: "Rate This Business",
              href: "#owner_view_business_rate_form_section",
            },
            {
              text: "Location Info",
              href: "#owner_view_business_location_section",
            },
            {
              text: "Working Schedules",
              href: "#owner_view_business_working_schedules_section",
            },
            {
              text: "Contact Information",
              href: "#owner_view_business_contact_info_section",
            },
            {
              text: "Contact / Message Form",
              href: "#owner_view_business_contact_us_form_section",
            },
            {
              text: "Photo Gallery",
              href: "#owner_view_business_photo_gallery_section",
            },
            {
              text: "Hash/ Search Tags",
              href: "#owner_view_business_meta_section",
            },
            {
              text: "Business Reviews",
              href: "#owner_view_business_reviews_list_section",
            },
            {
              text: "Post a Review Form",
              href: "#owner_view_business_review_form_section",
            }],
        });
      }
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user ? this._user.id : 0,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            //force schedule to be redrawn
            this.business_schedule_key_count =
              this.business_schedule_key_count + 1;
            this.business_schedule_key =
              "bsk_" + this.business_schedule_key_count;
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.send_parent_page_set_up();
            this.scroll_to("owner_view_business_name_section");
            if(this.is_in_public_view == true){
              this.truck_business_view();
            }
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading owners my business ", errors);
        }
      );
    },
    on_click_header_action(btn) {
      switch (btn.action) {
        case "rate_us":
          this.scroll_to("owner_view_business_rate_form_section");
          break;
        case "review_us":
          this.scroll_to("owner_view_business_review_form_section");
          break;
        case "message_us":
          this.scroll_to("owner_view_business_contact_us_form_section");
          break;
        case "verify":
          if(this.is_in_admin_view == true){
              this.$router.push(
                "/admin/businesses/list/view/" + this.business_id + "/verify"
              );
          }else{
            this.$router.push(
                "/owner/businesses/list/view/" + this.business_id + "/verify"
            );
          }
          break;
        case "edit_banner_image":
          this.$router.push(
            "/owner/businesses/list/view/" + this.business_id + "/edit_banner"
          );
          break;
        case "edit_basic_info":
          this.$router.push(
            "/owner/businesses/list/view/" + this.business_id + "/edit_info"
          );
          break;
        case "delete":
          if(this.is_in_admin_view == true){
            this.$router.push(
              "/admin/businesses/list/view/" + this.business_id + "/delete"
            );
          }else{
            this.$router.push(
              "/owner/businesses/list/view/" + this.business_id + "/delete"
            );
          }
          break;
        default:
          break;
      }
    },
    scroll_to(id) {
      var options = {
        offset: 60,
        duration: 1000,
        easing: "easeInOutCubic",
      };
      this.$vuetify.goTo("#" + id, options);
    },
    finished_rating_business() {
      //reload
      this.business_id = parseInt(this.$route.params.id);
      this.load_business(this.business_id);
    },
    no_rate_user_not_loggedin(rate) {
      this.$emit("on-show-login-modal", {
        action: "rating_business",
        value: rate,
      });
    },
    on_success_tags_updated() {
      //reload
      this.business_id = parseInt(this.$route.params.id);
      this.load_business(this.business_id);
    },
    finished_review_business() {
      //reload
      this.business_id = parseInt(this.$route.params.id);
      this.load_business(this.business_id);
    },
    no_review_user_not_loggedin(review) {
      this.$emit("on-show-login-modal", {
        action: "review_business",
        value: review,
      });
    },
    truck_business_view(){
      var today_str = Utils.get_today_date_str();
      var start_time_str = today_str + " 00:00:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);
      var end_time_str = today_str + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);
      ServerClient.Businesses.post_business_view({
        owner_id: this.business.user_id,
        id: this.business_id,
        user_id: (this._user && this._user != null)? parseInt(this._user.id) : 0,
        context: "public_business_view",
        page: "public_business_view",
        section: "center_section",
        today_str:  today_str,
        start_time: start_time,
        end_time: end_time,
        current_views_count: parseInt(this.business.views_count)
      },(res) => {
        console.log("Successfully registered business view ", res);
        this.business.views_count = parseInt(this.business.views_count) + 1;
      }, (errors) => {
        console.log("Errors while posting business view ", errors);
      });
    }
  },
  computed: {
    header_buttons() {
      var is_owner = this.is_owner;
      var is_admin = Utils.is_admin(this._user);

      var ls = [];
      //rate us button
      //should not display if its the owner &&
      //if its the admin
      if (is_owner == false && is_admin == false && this.is_in_admin_view == false && this.is_in_public_view == true) {
        ls.push({
          action: "rate_us",
          color: "success",
          icon: "mdi-pen",
          label: "Rate Us",
        });
      }
      //review button
      if (is_owner == false && is_admin == false && this.is_in_admin_view == false && this.is_in_public_view == true) {
        ls.push({
          action: "review_us",
          color: "success",
          icon: "mdi-pen",
          label: "Leave a review",
        });
      }
      //send message
      //also admin can send the business a message
      if (is_owner == false  && this.is_in_admin_view == false && this.is_in_public_view == true) {
        ls.push({
          action: "message_us",
          color: "success",
          icon: "mdi-pen",
          label: "Send Us a Message",
        });
      }
      //verify
      //only the owner can verify the business
      if ((is_owner == true || is_admin == true || this.is_in_admin_view == true) && this.is_in_public_view == false ) {
        ls.push({
          action: "verify",
          color: "success",
          icon: "mdi-pen",
          label: "Verify Business",
        });
      }
      //edit basic info & delete
      if ((is_owner == true && this.is_in_admin_view == false)  && this.is_in_public_view == false ) {
        ls.push({
          action: "edit_banner_image",
          color: "warning",
          icon: "mdi-pen",
          label: "Edit Banner Image",
        });
        ls.push({
          action: "edit_basic_info",
          color: "warning",
          icon: "mdi-pen",
          label: "Edit Basic Info",
        });
      }
      //edit button
      if ((is_owner == true || is_admin == true || this.is_in_admin_view == true)  && this.is_in_public_view == false ) {
        ls.push({
          action: "delete",
          color: "red",
          icon: "mdi-times",
          label: "Delete",
        });
      }
      return ls;
    },
    business_images() {
      var list = [];
      if (this.business && this.business.pictures) {
        for (var index = 0; index < this.business.pictures.length; index++) {
          var pic = this.business.pictures[index];
          list.push({
            id: pic.id,
            title: pic.description,
            url: pic.media_url,
            business_id: pic.business_id,
          });
          //{title:'Image1',url:'http://xxx.com/1.jpg'},
        }
      }
      return list;
    },
    hash_tags() {
      var tgs = [];
      return tgs;
    },
    this_user() {
      return this._user;
    },
  },
  mounted() {
    this.user_id = 0; //the public
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    if (this._user && this._user != null) {
      this.user_id = parseInt(this._user.id);
    }
    this.$emit("set-page-attributes", {
      title: "Business Details",
      crumps: [
        {
          text: "Home",
          disabled: false,
          href: "/",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/businesses/",
        },
        {
          text: "View",
          disabled: true,
          href: "businesses/view/" + this.business_id,
        },
      ],
      right_quick_links: [],
    });
    this.load_business(this.business_id);
  },
};
</script>

